import { render, staticRenderFns } from "./businessMemberItem.vue?vue&type=template&id=3fa22a9a&scoped=true"
import script from "./businessMemberItem.vue?vue&type=script&lang=js"
export * from "./businessMemberItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa22a9a",
  null
  
)

export default component.exports